import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ImportLineItem } from '../types';
import LineItemRow from './LineItemRow';

interface SortableLineItemRowProps {
  line: ImportLineItem;
  isLast: boolean;
  isHovered: boolean;
  isActive: boolean;
  modifiedFields: Set<string>;
  onUpdate: (id: string, field: keyof ImportLineItem, value: string | number | null) => void;
  onDelete: (id: string) => void;
  onMerge: (id: string) => void;
  onSplit: (id: string) => void;
  onHover: (id: string | null) => void;
  onClick: (id: string | null) => void;
  registerRef: (id: string, el: HTMLTableRowElement | null) => void;
  isSelected: boolean;
  onToggleSelect: (id: string, shiftKey: boolean) => void;
  renderExtraCells?: (line: ImportLineItem) => React.ReactNode;
  extraColumnCount?: number;
  hiddenColumns?: Set<string>;
}

const SortableLineItemRow: React.FC<SortableLineItemRowProps> = (props) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.line.id });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <tbody ref={setNodeRef} style={style}>
      <LineItemRow
        {...props}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </tbody>
  );
};

export default SortableLineItemRow;
